import type { IconData } from '@stacksjs/iconify-core'

export const cameraAltF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20 12H0V6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6zm0 2a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6zM6 15a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm4-4a4 4 0 1 0 0-8a4 4 0 0 0 0 8m6 0a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-6-2a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cameraAltF
